<template>
  <a-drawer width="40%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item :label="$t('上级分类')" prop="pid">
        <a-select v-model="form.pid" :placeholder="$t('顶级分类请选择')+' '+$t('无')" allow-clear :disabled="formType === 2">
          <a-select-option :value="0">{{ $t('顶级分类') }}</a-select-option>
          <a-select-option v-for="item in topOptions" :key="item.id" :value="item.id">{{ item.categoryName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('分类名称')" prop="categoryName">
        <a-input v-model="form.categoryName" :maxLength="32" :placeholder="$t('请输入')+$t('分类名称')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('分类图片')" prop="categoryPic">
        <oss-upload-single :height="100" :width="100" v-model="form.categoryPic" prefix="edu" type="img"/>
      </a-form-model-item>
      <a-form-model-item :label="$t('是否显示')" prop="isVisible">
        <a-switch v-model="form.isVisible" />
      </a-form-model-item>
      <a-form-model-item :label="$t('首页展示')" prop="isHomeVisible">
        <a-switch v-model="form.isHomeVisible" />
      </a-form-model-item>
      <a-form-model-item :label="$t('备注')" prop="remark">
        <a-input v-model="form.remark" :maxLength="200" :placeholder="$t('请输入')+$t('备注')" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getEduCategory, addEduCategory, updateEduCategory } from '@/api/edu/category'
import { mapGetters } from 'vuex'
import OssUploadSingle from "@/components/OssUploadSingle/index.vue"

export default {
  name: 'CreateForm',
  components: {
    OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      topOptions: [],
      form: this.initForm(),
      formType: 1,
      open: false,
      rules: {
        categoryName: [{ required: true, message: '分类名称不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    initForm() {
      return {
        id: null,
        categoryName: null,
        categoryPic: null,
        pid: 0,
        isVisible: true,
        isHomeVisible: false,
        remark: null
      }
    },
    onClose() {
      this.open = false
      this.reset()
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = this.initForm()
    },
    /** 新增按钮操作 */
    handleAdd(topOptions) {
      this.reset()
      this.topOptions = topOptions || []
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, topOptions) {
      this.reset()
      this.topOptions = topOptions || []
      this.formType = 2
      getEduCategory({ "id": row.id }).then(response => {
        const data = response.data
        this.form = {
          id: data.id,
          categoryName: data.categoryName,
          categoryPic: data.categoryPic,
          pid: data.pid,
          isVisible: data.isVisible,
          isHomeVisible: data.isHomeVisible,
          remark: data.remark
        }
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateEduCategory(this.form).then(response => {
              this.$message.success(this.$t('修改成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addEduCategory(this.form).then(response => {
              this.$message.success(this.$t('新增成功'), 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
